// Docs: https://developers.vtex.com/vtex-developer-docs/docs/vtex-io-documentation-serialize-delivery-estimations-date
// This function is used to serialize the delivery estimations date.
// It receives a date and returns a new date based on the current day.
// If the current day is Sunday, it returns the next Monday.
// If the current day is Saturday, it returns the next Monday.
// If the current day is any other day, it returns the next day if the current hour is before 12:00.
// If the current day is any other day, it returns the next day if the current hour is after 12:00.

import { isDaylightSavingTime } from "~/utils/is-daylight-saving-time"

export default function serializeDeliveryEstimationsDate(date: Date) {
  const currentDay = date.getUTCDay()
  let deliveryDate = new Date(date)
  const isDST = isDaylightSavingTime(date)
  const offset = isDST ? 3 : 2

  switch (currentDay) {
    case 0:
      deliveryDate.setDate(date.getDate() + 1)
      break
    case 5:
      deliveryDate.setDate(date.getUTCHours() + offset <= 14 ? date.getDate() : date.getDate() + 3)
      break
    case 6:
      deliveryDate.setDate(date.getDate() + 2)
      break
    case 7:
      deliveryDate.setDate(date.getDate() + 1)
      break
    default:
      deliveryDate.setDate(date.getUTCHours() + offset <= 14 ? date.getDate() : date.getDate() + 1)
      break
  }

  return deliveryDate
}
